/**
 * Which polls a fan may see and vote in.
 *
 * The club-level switch (club_settings.poll_enabled) wins over the poll's own
 * status: a poll the scheduler flipped to "open" stays invisible while the
 * club has the feature off. A missing flag counts as on, matching the column
 * default. Used for the home-screen button, the auto-open sheet and the sheet
 * itself, so all three agree.
 */
export function openPollsFor<T extends { status: string; options?: unknown[] | null }>(
  polls: readonly T[],
  pollEnabled: boolean | null | undefined,
): T[] {
  if (pollEnabled === false) return [];
  return polls.filter((p) => p.status === 'open' && (p.options?.length ?? 0) > 0);
}
